export default function AppError (message) {
  if (!(this instanceof AppError)) {
    return new AppError(message)
  }
  this.name = 'AppError'
  this.message = message
}
AppError.prototype = Object.create(Error.prototype)
AppError.prototype.constructor = AppError



// WEBPACK FOOTER //
// ./src/utils/errors.js